import { PADDING_CONTAINER } from '@/constants'
import { Container, ContainerProps } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'
import React from 'react'
type Props = {
  children: React.ReactNode
  sx?: SxProps<Theme>
} & ContainerProps

export const ContainerCustom = ({ children, sx, ...other }: Props) => {
  return (
    <Container
      disableGutters
      maxWidth={false}
      component={'section'}
      sx={{
        maxWidth: {
          xxl: '108rem',
        },
        paddingX: PADDING_CONTAINER,
        ...sx,
      }}
      {...other}
    >
      {children}
    </Container>
  )
}
